import React, { Component } from "react";
import {
  GridColumn,
  GridRow,
  Input,
  Button,
  Toastr,
} from "arv-reactcomponents";
import { Methods, Analytics } from "arv-extends";
import { FOOTER } from "npmlinks-constants";

const { EventFactory: Event } = Analytics;
const { validateEmail } = Methods;
const {
  NEWS_LETTER: { TITLE, PLACEHOLDER, CTA, SUCCESS, INVALID_EMAIL },
} = FOOTER;

class EmailSubscription extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
    };
    this.updateEmail = this.updateEmail.bind(this);
    this.submit = this.submit.bind(this);
  }
  updateEmail(event) {
    this.setState({ email: event.target.value });
  }
  submit() {
    const { email } = this.state;
    if (validateEmail(email)) {
      Analytics.default.trackEvent({
        action: Event.action.SUBSCRIBE_USER,
        category: Event.category.FOOTER,
        label: Event.label.getEmailSubscribeLabel(email),
      });
      Toastr.showToastr({
        className: "nwc-toastr-list-success nw-toastr",
        message: SUCCESS,
        timeout: 3000,
      });
    } else {
      Toastr.showToastr({
        className: "nwc-toastr-list-notification nw-toastr",
        message: INVALID_EMAIL,
        timeout: 3000,
      });
    }
  }
  render() {
    const { email } = this.state;
    return (
      <GridColumn className="nwc-grid-col-sm-4 wc-newsletter-container">
        <GridRow>
          <GridColumn>
            <h3 className="wc-newsletter-heading">{TITLE}</h3>
          </GridColumn>
          <GridColumn className="wc-newsletter-inputsection">
            <Input
              onChange={this.updateEmail}
              value={email}
              placeholder={PLACEHOLDER}
              className="wc-newsletter-input"
            />
            <Button
              onClick={this.submit}
              className="nwc-btn-primary wc-newsletter-button"
            >
              {CTA}
            </Button>
          </GridColumn>
        </GridRow>
      </GridColumn>
    );
  }
}

export default EmailSubscription;
